import { useEffect } from 'react';
import cn from 'classnames';

import Footer from '../Footer';
import Header from '../Header';
import SeoHelmet from '../SeoHelmet';

import style from './LegalTermWrapper.module.scss';

const LegalTermWrapper = ({ children, pageTitle, documentTitle }) => {
  useEffect(() => {
    document.documentElement.classList.add('nav-light');
    return () => document.documentElement.classList.remove('nav-light');
  }, []);

  return (
    <>
      <SeoHelmet
        title={pageTitle}
        description={pageTitle}
      />
      <Header />
      <main>
        <section className={cn('sec tone-light', style.page)}>
          <div className={cn('wrap', style.wrapper)}>
            <h1 className={cn('h2', style.title)}>{documentTitle || pageTitle}</h1>
            <div className={style.content}>{children}</div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default LegalTermWrapper;
